import { render, staticRenderFns } from "./smallItem.vue?vue&type=template&id=44333114&scoped=true&"
import script from "./smallItem.vue?vue&type=script&lang=ts&"
export * from "./smallItem.vue?vue&type=script&lang=ts&"
import style0 from "./smallItem.vue?vue&type=style&index=0&id=44333114&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44333114",
  null
  
)

export default component.exports